import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PreviousPathContext } from '../../contexts';

const PreviousPathProvider = ({ children }) => {
  const [previousPath, setPreviousPath] = useState(undefined);
  return (
    <PreviousPathContext.Provider value={{ previousPath, setPreviousPath }}>
      {children}
    </PreviousPathContext.Provider>
  );
};

PreviousPathProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PreviousPathProvider;
